import { getAllCookies } from 'common/selectors';
import { useSelector } from 'react-redux';
import { createSelector } from 'reselect';

const enum VariantID {
  A = '0',
  B = '1054040',
  C = '1054041',
  D = '1054042',
}

export const useMonetizationTestVariant = () => {
  const getVariantCookie = createSelector(getAllCookies, (cookie) => cookie.monetization_pdp_abcd);

  const variantId = useSelector(getVariantCookie);

  const nonTest = variantId === undefined;

  return {
    showComplementsPlacement: nonTest || variantId === VariantID.B,
    showSubstitutesPlacement: nonTest || variantId === VariantID.C,
    showSuggestionsPlacement: nonTest || variantId === VariantID.D,
  };
};
